var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForwardBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.6401 11.2132C1.49237 11.06 1.4578 10.8301 1.55394 10.6403L2.02161 9.71666C3.12845 7.53078 5.37042 6.15302 7.82056 6.15302H8.05049C8.06726 5.78877 8.08891 5.42469 8.11543 5.06087L8.16065 4.44044C8.19743 3.9359 8.76002 3.65385 9.18631 3.92624C10.5847 4.81981 11.8005 5.97121 12.7687 7.31904L13.0728 7.74234C13.198 7.91665 13.198 8.15144 13.0728 8.32576L12.7687 8.74905C11.8005 10.0969 10.5847 11.2483 9.18631 12.1419C8.76002 12.4142 8.19743 12.1322 8.16065 11.6276L8.11543 11.0072C8.08375 10.5727 8.05903 10.1379 8.04127 9.70281C6.60805 9.66143 5.17658 9.95071 3.861 10.5579L2.20954 11.3201C2.01632 11.4093 1.78782 11.3664 1.6401 11.2132ZM3.11893 9.79902L3.44194 9.64994C5.04937 8.90805 6.81305 8.59485 8.56314 8.72926C8.81801 8.74884 9.01707 8.95751 9.02463 9.21302C9.04161 9.78726 9.07099 10.3612 9.11278 10.9345L9.1164 10.9842C10.212 10.2097 11.1722 9.25746 11.9565 8.16563L12.051 8.03405L11.9565 7.90246C11.1722 6.81063 10.212 5.85837 9.1164 5.08393L9.11278 5.13357C9.07548 5.64531 9.04806 6.15759 9.03053 6.67012C9.02131 6.93945 8.80031 7.15302 8.53082 7.15302L7.82056 7.15302C5.88902 7.15302 4.11037 8.16496 3.11893 9.79902Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardBlack);
export default __webpack_public_path__ + "static/media/Forward_Black.e9c20449aeeadfa8bb688ed07fd33a83.svg";
export { ForwardRef as ReactComponent };